<template>
    <div class="item-classes" :class="itemClasses">
      <div
        class="sm:wf-w-1/2 md:wf-w-1/3 lg:wf-w-1/5"
        :class="classes"
        v-for="item in items"
        :key="item.id"
      >
        <img
          class="wf-h-full"
          :class="contentClasses"
          :src="item.url"
          :alt="item.alt"
        />
      </div>
    </div>
</template>

<script>
  export default {
    props: {
      items: {
        type: [Array, Object],
        default: () => []
      },
      classes: {
        type: [Array, Object],
        default: () => []
      },
      itemClasses: {
        type: [Array, Object],
        default: () => []
      },
      contentClasses: {
        type: Array,
        default: () => []
      }
    },
    mounted() {
      console.log(this.itemClasses, 'itemClasses')
    }
  }
</script>

<style scoped></style>
